"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const convertEventDetails_1 = require("./convertEventDetails");
const getBeaconEventNames_1 = __importDefault(require("./getBeaconEventNames"));
/**
 * Get details from the event registry formatted for a beacon payload. Only
 * include events present in the start and end queues. Throw a warning if an
 * event is specified in the start or end queues but not registered.
 *
 * @example
 *   // If the event registry contains these events...
 *
 *   {
 *     eventA: { thresholds: [100, 200] },
 *     eventB: { isDynamic: true, thresholds: [200, 300] },
 *     eventC: { thresholds: [600, 700] },
 *   };
 *
 *   // and only `eventA` and `eventB` are specified in the `eventsStart` and
 *   // `eventsEnd` arrays, then the returned array will be:
 *
 *   [
 *     { 'eventA': { thresholds: [100, 200] } },
 *     { 'eventB': { isDynamic: true, thresholds: [200, 300] } },
 *   ]
 *
 * @todo Add tests (including for duplicates)
 */
function getBeaconTrackedEvents(eventRegistry, eventsStart, eventsEnd) {
    // Get the list of event names from the start and end queues
    const eventNames = (0, getBeaconEventNames_1.default)(eventsStart, eventsEnd);
    // Grab details for the specified events from the event registry
    const trackedEvents = [];
    eventNames.forEach((eventName) => {
        const eventDetails = eventRegistry[eventName];
        // Bail with a warning if the event is not registered
        if (eventDetails === undefined) {
            console.warn(`Event "${eventName}" is not registered and will be ignored.`);
            return;
        }
        const trackedEvent = (0, convertEventDetails_1.createTrackedEvent)(eventName, eventDetails);
        // The backend doesn't care about the "dynamic" flag, so leave it out of
        // the beacon payload to save bandwidth.
        delete trackedEvent[eventName].dynamicEvent;
        trackedEvents.push(trackedEvent);
    });
    return trackedEvents;
}
exports.default = getBeaconTrackedEvents;
